import { render, staticRenderFns } from "./NormalSearchNav236.vue?vue&type=template&id=b9c04a7a&scoped=true"
import script from "./NormalSearchNav236.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav236.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c04a7a",
  null
  
)

export default component.exports